import React, { useState, useEffect } from 'react';
import { MdSecurity } from 'react-icons/md';
import {
    Overlay,
    ConsentContainer,
    ConsentText,
    ButtonGroup,
    AcceptButton,
    RejectButton
} from './style';
import { message } from 'antd';

const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Check if the user has already made a choice
        const consent = localStorage.getItem('WiseAcademy-cookie-consent');
        if (!consent) {
            // Small delay for better UX
            const timer = setTimeout(() => setIsVisible(true), 1500);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('WiseAcademy-cookie-consent', 'accepted');
        setIsVisible(false);
        message.success({
            content: 'Experience enhanced! Cookies accepted.',
            style: { marginTop: '10vh' }
        });
    };

    const handleReject = () => {
        localStorage.setItem('WiseAcademy-cookie-consent', 'rejected');
        setIsVisible(false);
        message.info({
            content: 'Cookies rejected. Some features like session persistence might be limited.',
            style: { marginTop: '10vh' }
        });
    };

    if (!isVisible) return null;

    return (
        <Overlay>
            <ConsentContainer>
                <ConsentText>
                    <div className="header">
                        <MdSecurity className="cookie-icon" />
                        <div className="title">Cookie Preferences</div>
                    </div>
                    <p>
                        We use <strong>cookies</strong> to personalize your learning experience,
                        analyze our traffic, and keep your account secure.
                        Choose your preference to continue.
                    </p>
                </ConsentText>
                <ButtonGroup>
                    <AcceptButton onClick={handleAccept}>Accept All Cookies</AcceptButton>
                    <RejectButton onClick={handleReject}>Reject Non-Essential</RejectButton>
                </ButtonGroup>
            </ConsentContainer>
        </Overlay>
    );
};

export default CookieConsent;
